import { Switch, Route, useRouteMatch } from "react-router-dom";
import {
    ListOutlate,
    CreateOutlate
    // UpdateInvoiceScreen
} from "../screens/OutlateScreens";
import routes from "./URL";
export default function route() {
    return (
        <Switch>
            <Route
                path={routes.admin.outlate.root}
                component={ListOutlate}
            />
            
            <Route
                path={routes.admin.outlate.create}
                component={CreateOutlate}
            />
   
            {/* <Route
                path={routes.admin.coupon.update(":id")}
                component={UpdateInvoiceScreen}
            />  */}

            {/* <Route exact path={"/"} component={ListGalleryScreen} /> */}
        </Switch>
    );
}
